import { combineAuth } from './hr-authority';
import {HrCommonReadableAuthority} from "./hr-common-readable-authority";

export class PersonnelReadableAuthority extends HrCommonReadableAuthority {

    public static readonly PERSONNEL_BASE = "personnel";

    constructor(authority: string) {
        super(combineAuth(PersonnelReadableAuthority.PERSONNEL_BASE, authority));
    }

}
